export enum UserType {
  COMPANY = 'Company',
  USER = 'User',
}
